<template>
  <list-form
    action-type="edit"
    :list-value-data="listValueData"
    :submit-button-disabled="submitButtonDisabled"
    :loading="loading"
    @save="editValue"
    @updateListItems="updateListItems"
    :input-type="inputType"
  />
</template>

<script>
import ListForm from "@/components/SystemManagement/SystemSettings/ListsSettings/ListForm";
import { mapActions } from "vuex";
import utils from "@/utils";

export default {
  name: "UpdateList",

  components: { ListForm },

  data() {
    return {
      listValueData: {},
      loading: true,
      listItems: []
    };
  },

  computed: {
    /**
     * Indicates if the submit button is disabled or not
     * @return {Boolean}
     */
    submitButtonDisabled() {
      return !this.listValueData.name;
    },

    /**
     * Indicates if the list being edited is custom or not
     * @return {Boolean}
     */
    isCustomList() {
      return this.$route.params.isCustomList;
    },

    /**
     * Indicates the type of input for the item code
     * @return {String}
     */
    inputType() {
      if (this.selectedList) {
        if (this.selectedList.code_rules.data_type === "character varying") {
          return "text";
        } else {
          return "number";
        }
      }
    }
  },

  mounted() {
    this.fetchListByListName();
  },

  methods: {
    ...mapActions([
      "UPDATE_LIST",
      "GET_LIST_OF_LISTS",
      "editCustomList",
      "editCustomListValue",
      "UPDATE_LIST_ITEM"
    ]),

    /**
     * Edits the list
     * If it's a custom list the body is only the name and the definition
     * Else, the client_label and the hidden property are also sent
     * The executed methods are different because the BE endpoints are different
     */
    async editValue() {
      try {
        this.loading = true;
        let dataToSend = null;
        if (this.listValueData.custom_list) {
          dataToSend = {
            name: this.listValueData.name,
            definition: this.listValueData.definition
          };
          await this.editCustomList({
            listUuid: this.listValueData.uuid,
            newData: dataToSend
          });
        } else {
          dataToSend = {
            name: this.listValueData.name,
            client_label: this.listValueData.client_label,
            definition: this.listValueData.definition,
            hidden: this.listValueData.hidden
          };
          await this.UPDATE_LIST({
            uuid: this.listValueData.uuid,
            listValueData: dataToSend
          });
        }
        this.$router.back();
      } catch (error) {
        let errorMessage = utils.errorHandler(error);
        if (typeof errorMessage === "string") {
          this.$toasted.global.toast_error(errorMessage);
        }
      } finally {
        this.loading = false;
      }
    },

    /**
     * Gets the list by its name.
     */
    async fetchListByListName() {
      try {
        let listName = this.$route.params.listName;
        let result = await this.GET_LIST_OF_LISTS();
        let lists = result.data.data;
        let code = listName.replace("list_", "l_");
        this.listValueData = lists.find(list => list.code === code);
        this.listValueData = { ...this.listValueData };
        if (!this.listValueData) {
          return this.$router.replace("/error");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    updateListItems($event) {
      this.listItems = $event;
    },

    /**
     * Returns an object with the data to send to the BE
     * If the value if from a custom list, only the code and libelle are sent
     * Else, the whole object is sent
     * @return {Object}
     */
    getDataToSend() {
      return this.isCustomList
        ? {
            code: this.listValueData.code,
            libelle: this.listValueData.libelle
          }
        : {
            blocked: this.listValueData.blocked,
            client_code: this.listValueData.client_code,
            client_label: this.listValueData.client_label,
            definition: this.listValueData.definition,
            code: this.listValueData.code,
            index: this.listValueData.index,
            libelle: this.listValueData.libelle,
            deleted: this.listValueData.deleted
          };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SystemManagement/SystemSettings/ListsSettings/UpdateList.vue